import dayjs from 'dayjs';

import { AdvancedDashboardData } from '../../graphql/API';
import { SelectedPeriod } from '../../providers/AppDataContext';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardDataApi = async ({
  fromDate,
  toDate,
  by,
}: SelectedPeriod): Promise<AdvancedDashboardData> => {
  const result = await executeGql<AdvancedDashboardData>(adminGetAdvancedDashboardDataQuery, {
    fromDate: dayjs(fromDate).format('YYYY-MM-DD'),
    toDate: dayjs(toDate).format('YYYY-MM-DD'),
    by: by,
  });
  return processGqlResult<AdvancedDashboardData>('adminGetAdvancedDashboardData', result);
};

const adminGetAdvancedDashboardDataQuery = /* GraphQL */ `
  query AdminGetAdvancedDashboardData($fromDate: String!, $toDate: String!, $by: String!) {
    adminGetAdvancedDashboardData(fromDate: $fromDate, toDate: $toDate, by: $by) {
      totalActiveOffers
      totalActiveVenues
      totalActiveUsers
      totalRejectedUsers
      totalPendingUsers
      totalValueOfActiveOffersSpots
      totalPremiumVenues
      totalPremiumVenuesWithoutSubscription
      totalPremiumUsers
      totalModelCreditsInMonth
      totalVenueCreditsInMonth
      totalUsersBpLifestyle
      totalUsersBpSelect
      totalModelCreditsInFromToDate
      totalPremiumUsersInFromToDate
      totalPremiumVenuesInFromToDate
      totalVenueCreditsInFromToDate
      totalPremiumExpiredUsersInFromToDate
      totalStarterVenues
      totalPlusVenues
      totalPlusFreeVenues
      totalStarterFreeVenues
      totalScoutingActiveUsers
      totalScoutingRejectedUsers

      modelApplicationsInFromToDate
      registeredFreelancerModelsInFromToDate
      registeredModelsInFromToDate
      venueApplicationsInFromToDate
      reservationsInFromToDate

      totalActiveReservationsLastMonth
      totalUniqueActiveReservationsLastMonth
      totalPriorActiveReservations
      totalPriorUniqueActiveReservations
      totalPriorActiveModels

      totals {
        activeModelsLastMonth
        activeOffers
        activeVenues
        reach
        redeemedOfferValue
        activeVenuesWithOffer
      }
      lines {
        date
        modelApplicationsPending
        modelApplicationsActive
        modelApplicationsRejected
        venuesApproved
        venuesBlocked
        offersValuePerCategory {
          drink
          beauty
          food
          event
          experience
          fitness
          unknown
        }
        offersPerCategory {
          drink
          beauty
          food
          event
          experience
          fitness
          unknown
        }
        offersValue
        reservationsReserved
        reservationsCheckedIn
        reservationsCancelled
        reservationsNoShow
        premiumModel
        premiumExpiredModel
        premiumVenue
        creditPurchaseByModel
        creditPurchaseByVenue
      }
    }
  }
`;
